import { resolve } from "path";
import axios from "../../../../../../../../../Apicall/whatsAppRepository";
export default {
  fetchContacts({ commit }, payload) {
    return new Promise((resolve, reject) => {

      console.log("contact payload");
      axios
        .post("/contact/", payload)
        .then((response) => {
          commit("SET_CONTACTS", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchMessages({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/message/phone`, payload)
        .then((response) => {
          commit("SET_MESSAGES", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  sendMessage({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/message/send`, payload)
        .then((response) => {
          commit("ADD_NEW_MESSAGE", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  agent({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/message/agent/`, payload)
        .then((response) => {
          commit("ADD_AGENT_MESSAGES", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  checkexpstatus({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/message/checkexpstatus/`, payload)
        .then((response) => {
          commit("CHECK_EXP_STATUS", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  checkexpstatus({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/message/checkexpstatus/`, payload)
        .then((response) => {
          commit("CHECK_EXP_STATUS", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  sendtempletemsg({ commit }, payload) {
    const opctions={
      headers:{
        "Content-Type":"multipart/form-data"
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .post(`/message/sendtempletemsg/`,   
        payload,opctions

        )
        .then((response) => {
          commit("ADD_AGENT_MESSAGES", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  Updatecontact({ commit }, payload) {
    return new Promise((resolve, reject) => {

      console.log("contact payload");
      axios
        .post("/contact/Updatecontact/", payload)
        .then((response) => {
          
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  OptIn({ commit }, payload){
    return new Promise((resolve,reject)=>{
      axios.get('/optin/getAllOptinUser').then(res=>{
        resolve(res)
      }).catch(err=>{reject(err)})
    })
  },
  async setContact({ commit, dispatch }, payload) {
    await commit("SET_ACTIVE_CHAT", payload);
    await dispatch("fetchMessages", { phone: payload.phone });
  },
};
